export const SITE_CREATION_PAGE_TITLE = 'site-creation-page.title';
export const SITE_CREATION_PAGE_EMAIL_CHIP = 'site-creation-page.email-chip';
